// require('./bootstrap');

import Vue from "vue";

Vue.component("order", require("./Components/Order.vue").default);

const app = new Vue({
    el: "#app",
    component: ["order"],
    mounted() {}
});
